module.exports = __webpack_public_path__ + "img/main.98b6df00.jpg";